<template>
  <v-flex>
    <v-toolbar flat dark color="primary" class="elevation-1">
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="btn-add" v-if="CanCreate" :href="this.create">
        <v-icon left>fas fa-plus</v-icon>
        {{newLabel}}
      </v-btn>
    </v-toolbar>
    <div class="primary">
      <v-btn flat color="white" @click="dialogFilter=true">
        <v-icon>fas fa-filter</v-icon>Filters
      </v-btn>
      <v-chip
        v-for="(filter, index) in filters"
        :key="index"
        close
        @input="remove(filter.item)"
      >{{filter.field}} {{filter.filterType}} {{filter.filtervalue}}</v-chip>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :total-items="totalRows"
      :loading="loading"
      :must-sort="false"
      :rowsPerPageItems="[10,20,50,100]"
      class="elevation-3"
    >
      <template v-slot:actions-append>
        <v-btn flat icon color="primary" @click="reload">
          <v-icon size="15">fas fa-sync</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">Nothing to display here.</v-alert>
      </template>
      <template v-slot:items="props">
        <td
          v-for="(value,key) in props.item"
          v-bind:key="key"
          v-on:dblclick="Edit(props.item.Id)"
          :class="isHiddenColumn(key)"
          @contextmenu.prevent="$refs.menu.open($event,{name:props.item})"
          v-html="value"
        ></td>
      </template>
    </v-data-table>

    <!--tasto dx-->
    <vue-context ref="menu">
      <ul slot-scope="child">
        <li @click="Edit(child.data.name.Id)" v-if="!disableEdit">
          <i class="fas fa-pencil-alt"></i>
          <span>&nbsp; Edit</span>
        </li>
        <li @click="Delete(child.data.name.Id)" v-if="!disableDelete">
          <i class="fas fa-trash"></i>
          <span>&nbsp; Delete</span>
        </li>
        <slot v-bind:child="child"></slot>
      </ul>
    </vue-context>
    <v-snackbar v-model="snackbar.Visible" :color="snackbar.Color" :timeout="snackbar.Timeout">
      {{ snackbar.Message }}
      <v-btn dark flat @click="snackbar.Visible = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogDelete" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Eliminare l'oggetto selezionato?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="#5c6366" @click="dialogDelete = false;">NO</v-btn>
          <v-btn dark color="red darken-1" @click="dialogDelete = false;DeleteConfirmed()">SI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFilter" width="500">
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Add Filter</h3>
          </div>
        </v-card-title>
        <v-form>
          <v-layout row wrap class="pa-2">
            <v-flex md12>
              <v-select
                :items="headersFilter"
                color="#5c6366"
                v-model="column"
                label="Column"
                :error-messages="columnErrors"
                @input="filterFieldSelected"
                @blur="$v.column.$touch()"
              ></v-select>
            </v-flex>
            <v-flex md12>
              <v-select
                v-if="!isBoolean"
                :items="currentTypeFiltersList"
                color="#5c6366"
                v-model="filter"
                label="Filter"
                :error-messages="filterErrors"
                @input="$v.filter.$touch()"
                @blur="$v.filter.$touch()"
              ></v-select>
            </v-flex>
            <v-flex md12>
              <v-text-field
                v-if="!isBoolean"
                name="name"
                color="#5c6366"
                label="Value"
                v-model="value"
                :type="currentTypeFilters"
                :error-messages="valueErrors"
                @input="$v.value.$touch()"
                @blur="$v.value.$touch()"
              ></v-text-field>
              <v-switch v-if="isBoolean" v-model="valueBoolean" :label="`${currentFilter}`"></v-switch>
            </v-flex>
          </v-layout>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#5c6366" @click="addFilter">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<script>
import { VueContext } from 'vue-context'
import { required } from 'vuelidate/lib/validators'
import gridElementApi from "../apiLogisticsTool/gridElementApi.js";

const requiredMsg = 'Campo obbligatorio.'
export default {
  components: { VueContext },

  validations: {
    column: { required },
    value: { required },
    filter: { required }
  },

  props: {
    // titolo in alto a sinistra nell'header della griglia
    title: String,
    // testo del bottone di aggiunta elemento
    newLabel: String,
    // visualizzazione del bottone crea elemento
    CanCreate: Boolean,
    // nome del controller della webapi per fare le chiamate crud base
    controller: String,
    create: String,
    delete: String,
    edit: String,
    readAll: String,
    // lista delle colonne della griglia con i relativi settaggi {text:'Storage' value: 'Storage', sortable: false, width: '5', filterable: false, type: Boolean }
    // sono richiesti: value (nome colonna sul db) e type (solo se il tipo di dato è diverso da stringa)

    // filtri per colonne che non sono visualizzate nel front end ma che sulla tabella del db esistono
    customFilters: Array,
    // disabilito pulsante Edit menu contestuale
    disableEdit: Boolean,
    // disabilito pulsante Delete menu contestuale
    disableDelete: Boolean,
    // nomi colonne da nascondere
    hideColumns: Array,
    // refresh griglia
    refresh: Boolean,
    headers: Array
  },

  data () {
    return {

      snackbar: { Timeout: 10000, Visible: false },
      dialogDelete: false,
      dialogFilter: false,
      CurObj: '',
      items: [],
      totalRows: 0,
      filters: [],
      loading: true,
      column: '',
      filter: '',
      value: '',
      valueBoolean: false,
      isBoolean: false,
      currentFilter: '',
      pagination: {},
      headersFilter: [],
      currentTypeFilters: '',
      currentTypeFiltersList: []
    }
  },

  beforeMount: function () {
    this.CalculateHeadersFilter()
  },

  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    },
    filters: {
      handler () {
        this.reload()
      },
      deep: true
    },
    refresh: {
      handler () {
        this.reload()
      }
    }
  },

  methods: {
    //
    // DELETE
    // mostra il popup di conferma eliminazione elemento
    Delete: function (obj) {
      this.dialogDelete = true
      this.CurObj = null
      this.CurObj = obj
    },
    // dopo la conferma dell'eliminazione chiama la webapi per fare la delete vera e propria
    DeleteConfirmed: function () {

      gridElementApi.Call(this.delete, this.CurObj, "delete").then(result => {
          this.snackbar.Color = 'success'
          this.snackbar.Visible = true
          this.snackbar.Message = "Elemento eliminato"
          this.$emit("refreshMenu", "");
          this.reload()
      }).catch(result => {
          this.snackbar.Color = 'error'
          this.snackbar.Visible = true
          this.snackbar.Message = result.response.data
        })
    },

    //
    // EDIT
    //
    Edit: function (obj) {
      if (!this.disableEdit) {
        //console.log("grid edit:", this.edit + "/" + obj,obj)
        this.$router.push(this.edit + "/" + obj)
      }
    },

    //
    // READ
    //
    getDataFromApi () {
      this.loading = true
      let { sortBy, descending, page, rowsPerPage } = this.pagination
      
      if (!descending) {
        descending = false
      }

      if(!sortBy)
      { 
        sortBy = []; 
      }
      else
      { 
        sortBy=[sortBy]; 
      }
      
      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: rowsPerPage,
        filters: this.filters
      }
      return this.$http.post(this.controller + this.readAll + '/', filters)
    },

    reload () {
      // this.getDataFromApi().then(data => {
      //   this.loading = false
      //   this.items = data.data.items
      //   this.totalRows = data.data.totalRows

      //   this.CalculateHeadersFilter()
      // })
      
      this.loading = true
      let { sortBy, descending, page, rowsPerPage } = this.pagination
      
      if (!descending) {
        descending = false
      }

      if(!sortBy){
        sortBy = [];
      }
      else{
        sortBy=[sortBy];
      }

      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: rowsPerPage,
        filters: this.filters
      }

      gridElementApi.Call(this.controller + this.readAll, filters, "post").then(data => { 
        this.loading = false
        this.items = data.data.items
        this.totalRows = data.data.totalRows
        this.CalculateHeadersFilter()
      });
    },

    //
    // FILTERS
    //

    // Calcola i campi disponibili per essere filtrati
    CalculateHeadersFilter () {
      this.headersFilter = this.headers.slice()
      if (this.customFilters) {
        this.customFilters.forEach(cf => {
          this.headersFilter.push(cf)
        })
      }

      this.headersFilter.forEach(hf => {
        if (hf.filterable === false) {
          this.headersFilter.splice(this.headersFilter.indexOf(hf), 1)
        }
      })

      this.filters.forEach(filtr => {
        var index = -1
        this.headersFilter.forEach(hf => {
          if (hf.filterable === false) {
            index = this.headersFilter.indexOf(hf)
          }
          if (hf.value === filtr.field) {
            index = this.headersFilter.indexOf(hf)
          }
        })
        this.headersFilter.splice(index, 1)
      })
    },

    /// rimuove il filtro dalla lista dei filtri disponibili per evitare di filtrare piu volte lo stesso campo

    remove (item) {
      this.filters.splice(this.filters.indexOf(item), 1)
      this.filters = [...this.filters]
      this.CalculateHeadersFilter()
    },
    addFilter: function () {
      if (!this.isBoolean) {
        this.$v.$touch()
        if (this.$v.$error) return
      }
      var filter = {
        filterType: this.isBoolean ? 'Equal' : this.filter,
        field: this.column,
        filtervalue: this.isBoolean ? this.valueBoolean : this.value
      }

      this.filters.push(filter)
      this.dialogFilter = false
      this.filter = null
      this.column = null
      this.value = null
      this.isBoolean = false
      this.CalculateHeadersFilter()
    },
    // quando si cambia il campo da filtrare prepara il resto della form al tipo di dato del campo
    filterFieldSelected: function (field) {
      this.isBoolean = false
      this.headersFilter.forEach(hf => {
        if (hf.value === field) {
          switch (hf.type) {
            case Date:
              this.currentTypeFilters = 'Date'
              this.currentTypeFiltersList = ['From', 'To', 'Equal']
              break
            case Number:
              this.currentTypeFilters = 'Number'
              this.currentTypeFiltersList = ['Bigger', 'Smaller', 'Equal']
              break
            case Boolean:
              this.isBoolean = true
              this.filter = 'Equal'
              this.currentFilter = hf.text
              this.currentTypeFilters = 'Boolean'
              this.currentTypeFiltersList = ['Equal']
              break
            default:
              this.currentTypeFilters = 'Text'
              this.currentTypeFiltersList = ['StartWith', 'Contains']
              break
          }
        }
      })
    },
    //
    isHiddenColumn (key) {
      let classColumn = 'text-xs-left '
      if (this.hideColumns) {
        this.hideColumns.forEach(col => {
          if (col === key) {
            classColumn += 'hide-column text-xs-left'
          }
        })
      }
      if (key === 'RowNum') {
        classColumn += 'hide-column text-xs-left'
      }
      return classColumn
    }
    // isHiddenColumn: function (key) {
    //   this.hideColumns.forEach(col => {
    //     if (col === key) {
    //       return 'hide-column text-xs-left';
    //     } else {
    //       return 'text-xs-left';
    //     }
    //   });
    // }
  },
  computed: {
    // validazione campo filter
    filterErrors () {
      const errors = []
      if (!this.$v.filter.$dirty) return errors
      !this.$v.filter.required && errors.push(requiredMsg)
      return errors
    },
    // validazione campo column
    columnErrors () {
      const errors = []
      if (!this.$v.column.$dirty) return errors
      !this.$v.column.required && errors.push(requiredMsg)
      return errors
    },
    // validazione campo value
    valueErrors () {
      const errors = []
      if (!this.$v.value.$dirty) return errors
      !this.$v.value.required && errors.push(requiredMsg)
      return errors
    }
  }
}
</script>
<style>

.btn-add {
  background-color: white !important;
  color: #5c6366 !important;
}

.v-table__overflow {
  height: 63vh;
  overflow-y: auto !important;
}
.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}

table {
  table-layout: fixed;
}

th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

tr.v-datatable__progress th {
  height: 1px;
}

.v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}

.v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}

.v-datatable__actions {
  flex-wrap: nowrap;
}

.v-datatable__actions__pagination {
  white-space: nowrap;
}
.hide-column {
  display: none;
}
</style>
